import _construct from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseObject, copy, flat, get, init, isArray, isIterable, isString, merge, raw, set } from './__util__';
import { _facet } from './_facet';
import { _repeat } from './_repeat';
import { render as _render, toSpec as _toSpec, toString as _toString, toView as _toView } from './__view__';

var Layer = /*#__PURE__*/function (_BaseObject) {
  _inherits(Layer, _BaseObject);

  var _super = _createSuper(Layer);

  function Layer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, Layer);

    _this = _super.call(this);
    init(_assertThisInitialized(_this));
    args = flat(args);
    set(_assertThisInitialized(_this), "layer", args);
    return _this;
  }

  _createClass(Layer, [{
    key: "autosize",
    value: function autosize(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "autosize", value);
        return obj;
      } else {
        return get(this, "autosize");
      }
    }
  }, {
    key: "background",
    value: function background(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "background", value);
        return obj;
      } else {
        return get(this, "background");
      }
    }
  }, {
    key: "config",
    value: function config(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "config", value);
        return obj;
      } else {
        return get(this, "config");
      }
    }
  }, {
    key: "datasets",
    value: function datasets(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "datasets", value);
        return obj;
      } else {
        return get(this, "datasets");
      }
    }
  }, {
    key: "description",
    value: function description(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "description", value);
        return obj;
      } else {
        return get(this, "description");
      }
    }
  }, {
    key: "height",
    value: function height(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "height", value);
        return obj;
      } else {
        return get(this, "height");
      }
    }
  }, {
    key: "layer",
    value: function layer() {
      for (var _len2 = arguments.length, value = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        value[_key2] = arguments[_key2];
      }

      if (arguments.length) {
        var obj = copy(this);
        value = flat(value);
        set(obj, "layer", value);
        return obj;
      } else {
        return get(this, "layer");
      }
    }
  }, {
    key: "name",
    value: function name(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "name", value);
        return obj;
      } else {
        return get(this, "name");
      }
    }
  }, {
    key: "padding",
    value: function padding(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "padding", value);
        return obj;
      } else {
        return get(this, "padding");
      }
    }
  }, {
    key: "params",
    value: function params() {
      for (var _len3 = arguments.length, value = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        value[_key3] = arguments[_key3];
      }

      if (arguments.length) {
        var obj = copy(this);
        value = flat(value);
        set(obj, "params", value);
        return obj;
      } else {
        return get(this, "params");
      }
    }
  }, {
    key: "resolve",
    value: function resolve(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "resolve", value);
        return obj;
      } else {
        return get(this, "resolve");
      }
    }
  }, {
    key: "title",
    value: function title(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "title", value);
        return obj;
      } else {
        return get(this, "title");
      }
    }
  }, {
    key: "usermeta",
    value: function usermeta(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "usermeta", value);
        return obj;
      } else {
        return get(this, "usermeta");
      }
    }
  }, {
    key: "view",
    value: function view(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "view", value);
        return obj;
      } else {
        return get(this, "view");
      }
    }
  }, {
    key: "width",
    value: function width(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "width", value);
        return obj;
      } else {
        return get(this, "width");
      }
    }
  }, {
    key: "project",
    value: function project(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "projection", value);
        return obj;
      } else {
        return get(this, "projection");
      }
    }
  }, {
    key: "encode",
    value: function encode() {
      for (var _len4 = arguments.length, values = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        values[_key4] = arguments[_key4];
      }

      if (values.length === 1 && Array.isArray(values[0])) {
        values = values[0];
      }

      if (values.length) {
        var val = get(this, "encoding");
        var obj = copy(this);
        if (val) values = [val].concat(values);
        set(obj, "encoding", merge(1, values));
        return obj;
      } else {
        return get(this, "encoding");
      }
    }
  }, {
    key: "data",
    value: function data(value) {
      if (arguments.length) {
        var obj = copy(this);
        value = isArray(value) ? {
          values: raw(value)
        } : isIterable(value) ? {
          values: raw(value)
        } : isString(value) ? {
          url: value
        } : value;
        set(obj, "data", value);
        return obj;
      } else {
        return get(this, "data");
      }
    }
  }, {
    key: "transform",
    value: function transform() {
      for (var _len5 = arguments.length, value = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        value[_key5] = arguments[_key5];
      }

      if (arguments.length) {
        var obj = copy(this);
        value = flat(value);
        set(obj, "transform", value);
        return obj;
      } else {
        return get(this, "transform");
      }
    }
  }, {
    key: "facet",
    value: function facet() {
      for (var _len6 = arguments.length, values = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        values[_key6] = arguments[_key6];
      }

      values = values.slice(0, 1);

      var obj = _facet.apply(void 0, _toConsumableArray(values));

      return obj.spec(this);
    }
  }, {
    key: "repeat",
    value: function repeat() {
      for (var _len7 = arguments.length, values = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        values[_key7] = arguments[_key7];
      }

      values = values.slice(0, 1);

      var obj = _repeat.apply(void 0, _toConsumableArray(values));

      return obj.spec(this);
    }
  }, {
    key: "render",
    value: function render() {
      for (var _len8 = arguments.length, values = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        values[_key8] = arguments[_key8];
      }

      return _render.apply(this, values);
    }
  }, {
    key: "toView",
    value: function toView() {
      for (var _len9 = arguments.length, values = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        values[_key9] = arguments[_key9];
      }

      return _toView.apply(this, values);
    }
  }, {
    key: "toSpec",
    value: function toSpec() {
      for (var _len10 = arguments.length, values = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        values[_key10] = arguments[_key10];
      }

      return _toSpec.apply(this, values);
    }
  }, {
    key: "toString",
    value: function toString() {
      for (var _len11 = arguments.length, values = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        values[_key11] = arguments[_key11];
      }

      return _toString.apply(this, values);
    }
  }]);

  return Layer;
}(BaseObject);

export function layer() {
  for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }

  return _construct(Layer, args);
}